import { Assembler } from '@iotv/datamodel';
import ApiGateway from '../aws/api-gateway/ApiGateway';
const debug = process.env.REACT_APP_DEBUG && false;
const apiRef = 'SystemManagementApi';
const listCustomers = async (contextRequest) => {
    let response = { err: null, data: null };
    if (contextRequest.contextUser) {
        try {
            response = await ApiGateway.post('/system/Customer/list', contextRequest, apiRef);
            debug && console.log('listCustomers query results', { contextRequest, response });
        }
        catch (e) {
            response.err = e;
            debug && console.log('Error in listCustomers query', e);
        }
    }
    return response;
};
const getCustomer = async ({ contextUser, relatedObjectSk }) => {
    let response = { err: null, data: null };
    if (contextUser) {
        const contextCustomer = Assembler.getZombieFromPrimaryKey(relatedObjectSk);
        try {
            debug && console.log('getCustomer user', contextUser);
            response = await ApiGateway.post(`/system/Customer/get`, { contextUser, contextCustomer }, apiRef);
        }
        catch (e) {
            response.err = e;
            debug && console.log('Error in getCustomer query', e);
        }
    }
    return response;
};
const addCustomer = async ({ contextUser, newCustomer, parentCustomer }) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/Customer/add', { contextUser, newCustomer, parentCustomer }, apiRef);
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
const updateCustomer = async ({ contextUser, customer }) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/Customer/update', { contextUser, customer }, apiRef);
        debug && console.log('updateCustomer response', response);
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
const deleteCustomer = async ({ contextUser, customer }) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/Customer/delete', { contextUser, customer }, apiRef);
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
const getCustomerContext = async ({ contextUser, customer, accountType, accountRelationship, ExclusiveStartKey }) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/Customer/context', { contextUser, customer, accountType, accountRelationship, ExclusiveStartKey }, apiRef);
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
const getCustomerParents = async ({ contextUser, contextCustomer, ExclusiveStartKey }) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/Customer/parents', { contextUser, contextCustomer, ExclusiveStartKey }, apiRef);
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
const canAdminCustomer = async ({ contextUser, customer }) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/Customer/canAdminCustomer', { contextUser, customer }, apiRef);
        debug && console.log(`canAdminCustomer res`, { request: { contextUser, customer }, response });
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
const isUserForCustomer = async ({ contextUser, customer }) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/Customer/isUserForCustomer', { contextUser, customer }, apiRef);
        debug && console.log('isUserForCustomer res', { request: { contextUser, customer }, response });
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
/**
 * **Customer DAO**
 */
export const CustomerDAO = {
    listCustomers,
    getCustomer,
    addCustomer,
    updateCustomer,
    deleteCustomer,
    getCustomerContext,
    getCustomerParents,
    canAdminCustomer,
    isUserForCustomer,
};
